import hot from "handsontable";
const Handsontable = {
  settings(disableVisualSelection) {
    return {
      licenseKey: "non-commercial-and-evaluation",
      className: "text-3xs w-full",
      disableVisualSelection: disableVisualSelection == undefined ? true : disableVisualSelection,
      stretchH: "all",
      rowHeaders: true,
      colHeaders: true,
      autoRowSize: false,
      autoColumnSize: false,
      //data: [],
      //columns: [],
      dropdownMenu: ["filter_by_value", "filter_action_bar"], //['filter_by_condition', 'filter_action_bar', 'filter_by_value'],
      contextMenu: ["hidden_columns_show", "hidden_columns_hide"],
      //manualColumnMove: true, //There is a bug when moving columns and then hiding them
      manualColumnResize: true,
      filters: true,
      hiddenColumns: {
        columns: [],
        indicators: true
      },
      columnSorting: {
        sortEmptyCells: true,
        initialConfig: {
          column: 0,
          sortOrder: "asc"
        }
      },
      afterChange: function (changes, source) {
        if (source === "loadData") {
          const ColumnSorting = this.getPlugin("ColumnSorting");
          ColumnSorting.sort(ColumnSorting.getSortConfig());
        }
      }
    };
  },

  monthRenderer: function (instance, td, row, col, prop, value, cellProperties) {
    hot.renderers.TextRenderer.apply(this, arguments);
    if (value == 1) td.innerHTML = "January";
    if (value == 2) td.innerHTML = "February";
    if (value == 3) td.innerHTML = "March";
    if (value == 4) td.innerHTML = "April";
    if (value == 5) td.innerHTML = "May";
    if (value == 6) td.innerHTML = "June";
    if (value == 7) td.innerHTML = "July";
    if (value == 8) td.innerHTML = "August";
    if (value == 9) td.innerHTML = "September";
    if (value == 10) td.innerHTML = "October";
    if (value == 11) td.innerHTML = "November";
    if (value == 12) td.innerHTML = "December";
  },
  contextMenuRenderer: function (hot, wrapper, row, col, prop, itemValue) {
    var elem = document.createElement("div");
    elem.className = "text-2xs hover:bg-gray-200 hover:cursor-pointer";
    elem.innerHTML = itemValue;
    return elem;
  },
  contextMenuTitleRenderer: function (hot, wrapper, row, col, prop, itemValue) {
    var elem = document.createElement("div");
    elem.className = "text-xs font-bold";
    elem.innerHTML = itemValue;
    return elem;
  },
  generateGuid: function(){
    var guid = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
    return '{'+guid+'}';
  }
};

export default Handsontable;
